export let APIEnvironment = /*#__PURE__*/function (APIEnvironment) {
  APIEnvironment["local"] = "local";
  APIEnvironment["development"] = "development";
  APIEnvironment["test"] = "test";
  APIEnvironment["production"] = "production";
  return APIEnvironment;
}({});
export let TrackingEvents = /*#__PURE__*/function (TrackingEvents) {
  TrackingEvents["productImpression"] = "productImpression";
  TrackingEvents["addToCart"] = "addToCart";
  TrackingEvents["productClick"] = "productClick";
  TrackingEvents["slider"] = "slider";
  return TrackingEvents;
}({});
export let Currency = /*#__PURE__*/function (Currency) {
  Currency["chf"] = "CHF";
  return Currency;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["self"] = "_self";
  Target["blank"] = "_blank";
  return Target;
}({});
export let ResponseStatus = /*#__PURE__*/function (ResponseStatus) {
  ResponseStatus["error"] = "ERROR";
  ResponseStatus["empty"] = "EMPTY";
  ResponseStatus["ok"] = "OK";
  return ResponseStatus;
}({});
export let Order = /*#__PURE__*/function (Order) {
  Order["desc"] = "desc";
  Order["asc"] = "asc";
  return Order;
}({});
export let Region = /*#__PURE__*/function (Region) {
  Region["national"] = "national";
  Region["gmaa"] = "gmaa";
  Region["gmbs"] = "gmbs";
  Region["gmge"] = "gmge";
  Region["gmlu"] = "gmlu";
  Region["gmnf"] = "gmnf";
  Region["gmos"] = "gmos";
  Region["gmti"] = "gmti";
  Region["gmvd"] = "gmvd";
  Region["gmvs"] = "gmvs";
  Region["gmzh"] = "gmzh";
  Region["all"] = "all";
  Region["regional"] = "regional";
  return Region;
}({});
export let Retailer = /*#__PURE__*/function (Retailer) {
  Retailer["supermarkt"] = "supermarkt";
  Retailer["leshop"] = "leshop";
  Retailer["migros_online"] = "migros_online";
  return Retailer;
}({});
export let SortProducts = /*#__PURE__*/function (SortProducts) {
  SortProducts["score"] = "score";
  SortProducts["price"] = "price";
  SortProducts["category"] = "category";
  SortProducts["id"] = "id";
  SortProducts["name"] = "name";
  SortProducts["likes"] = "likes";
  SortProducts["likesweek"] = "likesweek";
  SortProducts["rating"] = "rating";
  SortProducts["rating_rounded"] = "rating_rounded";
  SortProducts["reviews"] = "reviews";
  SortProducts["updated_at"] = "updated_at";
  SortProducts["amigos"] = "amigos";
  return SortProducts;
}({});
export let SortOffers = /*#__PURE__*/function (SortOffers) {
  SortOffers["discount"] = "discount";
  SortOffers["price"] = "price";
  SortOffers["description"] = "description";
  SortOffers["start_date"] = "start_date";
  SortOffers["end_date"] = "end_date";
  SortOffers["type_id"] = "type_id";
  SortOffers["category"] = "category";
  SortOffers["recommended"] = "recommended";
  return SortOffers;
}({});
export let HeadingTags = /*#__PURE__*/function (HeadingTags) {
  HeadingTags["h1"] = "h1";
  HeadingTags["h2"] = "h2";
  HeadingTags["h3"] = "h3";
  HeadingTags["h4"] = "h4";
  HeadingTags["h5"] = "h5";
  HeadingTags["h6"] = "h6";
  return HeadingTags;
}({});
export let ListStyleType = /*#__PURE__*/function (ListStyleType) {
  ListStyleType["default"] = "default";
  ListStyleType["fancy"] = "fancy";
  ListStyleType["condensed"] = "condensed";
  return ListStyleType;
}({});
export let TileLayout = /*#__PURE__*/function (TileLayout) {
  TileLayout["default"] = "default";
  TileLayout["mini"] = "mini";
  return TileLayout;
}({});